import { render, staticRenderFns } from "./muokkaa-arvioitavan-kokonaisuuden-kategoriaa.vue?vue&type=template&id=aea8eea6&scoped=true&"
import script from "./muokkaa-arvioitavan-kokonaisuuden-kategoriaa.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-arvioitavan-kokonaisuuden-kategoriaa.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-arvioitavan-kokonaisuuden-kategoriaa.vue?vue&type=style&index=0&id=aea8eea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea8eea6",
  null
  
)

export default component.exports